import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { BrowserTracing } from '@sentry/tracing';
import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.sentry.enabled) {
	Sentry.init({
		dsn: 'https://b087158232384d8fa5d7a10e493b2628@sentry.aic.serpro.gov.br/1123',
		environment: environment.sentry?.environment || 'local',
		integrations: [
			new Sentry.BrowserTracing({
				tracePropagationTargets: environment.sentry?.tracePropagationTargets || [
					'local.desenv-oportunidades-sigepe-talentos.estaleiro.serpro.gov.br'
				],
				routingInstrumentation: Sentry.routingInstrumentation
			}),
			new Sentry.Replay()
		],

		replaysSessionSampleRate: environment.sentry.environment === 'homolog' ? 1.0 : 0.1,
		replaysOnErrorSampleRate: environment.sentry.environment === 'homolog' ? 1.0 : 0.1,
		tracesSampleRate: environment.sentry.environment === 'homolog' ? 1.0 : 0.2
	});
}

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
